import React from 'react';
import PropTypes from 'prop-types';

import { Paragraph, Text } from 'components/core/Typography';
import { amenityObject } from 'config/content';

import './PaginationSummary.scss';
import { simpleAmenityTextMap } from '../../../config/amenityMap';

export function PaginationSummary({
	city,
	state,
	listingsPerPage,
	page,
	pageListingsCount,
	totalItems,
	amenityType,
}) {
	const first = pageListingsCount ? (page - 1) * listingsPerPage + 1 : 0;
	const last = pageListingsCount ? first + pageListingsCount - 1 : 0;
	const isSpecialAmenity =
		amenityType === 'climate-controlled' ||
		amenityType === '24-hour-access' ||
		amenityType === 'drive-up-self-storage' ||
		amenityType === 'free-truck-rental';

	return (
		<>
			{city && state ? (
				<Paragraph
					className="pagination-summary"
					size="smallMedium"
					weight="standard"
					color="darkGray"
				>
					{first} - {last} of {totalItems} Cheap{' '}
					{simpleAmenityTextMap[amenityType] || 'Self'} Storage
					Facilities in {city}, {state}
				</Paragraph>
			) : (
				<Text
					className="pagination-summary"
					size="smallMedium"
					weight="standard"
					color="darkGray"
				>
					<Text
						size="smallMedium"
						weight="standard"
						color="placeholderGray"
						last
					>
						{' '}
						•{' '}
					</Text>
					{first} - {last} of {totalItems}{' '}
					{isSpecialAmenity
						? `${amenityObject[amenityType]} Facilities`
						: `${amenityObject[amenityType]} Storage Facilities`}
				</Text>
			)}
		</>
	);
}

PaginationSummary.propTypes = {
	city: PropTypes.string,
	listingsPerPage: PropTypes.number,
	page: PropTypes.number,
	pageListingsCount: PropTypes.number,
	state: PropTypes.string,
	totalItems: PropTypes.number,
	amenityType: PropTypes.string,
};

PaginationSummary.defaultProps = {
	totalItems: 0,
	pageListingsCount: 0,
};

export default PaginationSummary;
